/** sessionStorage 中会话 ID 的 key */
export const SESSION_STORAGE_KEY = 'track_session_id';

/** 调试开关 localStorage key */
export const DEBUG_STORAGE_KEY = 'TRACK_DEBUG';

/** 单次批量上报最大条数 */
export const BATCH_SIZE = 10;

/** 定时冲刷间隔（毫秒） */
export const FLUSH_INTERVAL_MS = 5000;

/** 上报失败最大重试次数 */
export const MAX_RETRY = 2;

/** 埋点上报接口路径 */
export const BATCH_REPORT_PATH = '/Api/Track/batchReport';
